import {
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonDatetime,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonModal,
  IonPage,
  IonRow,
  IonSearchbar,
  IonSegment,
  IonSegmentButton,
  IonTitle,
  IonToolbar,
  useIonLoading
} from '@ionic/react'
import { arrowBack, checkmarkCircle, flag, refresh, star } from 'ionicons/icons'
import { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import ActionSheet from '../../components/ActionSheet'
import AddButton from '../../components/AddButton'
import ViewData from '../../components/ViewData'
import { ACCEPTED, COUNTRY, EMPTY, ENDED, INITIALIZED, OPERATION_TYPE } from '../../const/constants'
import { useAppContext } from '../../context/AppContext'
import useMessages from '../../hooks/useMessages'
import { saveTramites, storeProcedureDetail } from '../../redux/actions'
import { getProcedures } from '../../services/api/dig-documents-manager'
import { formatDate, toISOString } from '../../utils/utils'

const Portabilidades = () => {
  const TODAY = new Date()
  const dateFromModal = useRef<HTMLIonModalElement>(null)
  const dateToModal = useRef<HTMLIonModalElement>(null)
  const TODAY_DATE_STRING = toISOString(TODAY)
  const ONE_MONTH_AGO_DATE = toISOString(new Date(TODAY.getFullYear(), TODAY.getMonth() - 1, TODAY.getDate()))

  const [tab, setTab] = useState(INITIALIZED)
  const [startDate, setStartDate]: any = useState(ONE_MONTH_AGO_DATE)
  const [endDate, setEndDate]: any = useState(TODAY_DATE_STRING)
  const [search, setSearch]: any = useState('')
  const [onLoading, setOnLoading] = useState(false)

  const [showActionSheet, setShowActionSheet] = useState(false)
  const [data, setData]: any = useState({})

  const [procedures, setProcedures]: any = useState([])
  const dispatch = useDispatch()
  const { user, settings }: any = useAppContext()

  const [present, dismiss] = useIonLoading()

  const initialQueriesState = {
    operationType: OPERATION_TYPE.portabilidades,
    state: tab.toUpperCase(),
    name: EMPTY,
    identificationNumber: EMPTY,
    user: user.posNumber,
    startDate: ONE_MONTH_AGO_DATE,
    endDate: TODAY_DATE_STRING
  }

  const [queries, setQueries] = useState(initialQueriesState)

  const history = useHistory()

  const { toastMessage } = useMessages()

  const serviceRequest = async (queryParams: any) => {
    const response = await getProcedures(queryParams)
    dispatch(saveTramites(response))
    setProcedures(response)
  }

  const loadData = async (queriesValues?: any) => {
    setOnLoading(true)
    const queryParams = queriesValues || queries

    present({
      message: 'Cargando trámites. <br/> Esperá por favor.'
    })
    try {
      await serviceRequest(queryParams)
    } catch (error: any) {
      setProcedures([])
      toastMessage('No se pudieron obtener los trámites.', 3000, 'bottom', 'error')
    } finally {
      dismiss()
      setOnLoading(false)
    }
  }

  const onTabChange = async (event: any) => {
    if (onLoading) return
    const actualTab = event.detail.value.toUpperCase()
    setTab(actualTab)
    setQueries({ ...queries, state: actualTab })
    if (search) setSearch('')
  }

  useEffect(() => {
    if (onLoading) return
    loadData({ ...queries, state: tab })
  }, [tab])

  const dateSelectHandler = (event: any) => {
    if (event.target.name === 'startDate') setStartDate(event.detail.value)
    else setEndDate(event.detail.value)

    const queriesValues = {
      ...queries,
      name: search,
      [event.target.name]: toISOString(event.target.value)
    }

    setQueries(queriesValues)
    loadData(queriesValues)
  }

  const searchHandler = (event: any) => {
    if (onLoading) return
    const value = event.target.value

    if (!value.length) {
      loadData({ ...queries, name: '' })
      setQueries({
        ...queries,
        name: ''
      })
    }

    setSearch(value)
    if (value.length < 3) return

    serviceRequest({ ...queries, name: value })
  }

  const reloadData = () => {
    setSearch('')
    setStartDate(ONE_MONTH_AGO_DATE)
    setEndDate(TODAY_DATE_STRING)
    loadData({
      ...queries,
      startDate: ONE_MONTH_AGO_DATE,
      endDate: TODAY_DATE_STRING
    })
  }

  const viewProcedureDetail = (procedure: any) => {
    dispatch(storeProcedureDetail(procedure))
    setData(procedure)
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={(e) => history.push('/procedures')}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Portabilidad Prepaga</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={reloadData}>
              <IonIcon icon={refresh} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <AddButton
          id="nueva-portabilidad"
          href={
            settings.country === COUNTRY.PY
              ? '/procedures/portabilidades/nueva-portabilidad-py'
              : '/procedures/portabilidades/nueva-portabilidad'
          }
          blockNavigation
          procedure="portabilidad"
        />
        <ActionSheet
          data={data}
          procedure="portability"
          showActionSheet={showActionSheet}
          setShowActionSheet={setShowActionSheet}
        />
        <IonSegment value={tab} onIonChange={onTabChange}>
          <IonSegmentButton value={INITIALIZED}>
            <IonIcon icon={checkmarkCircle} />
            <IonLabel>A completar</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value={ACCEPTED}>
            <IonIcon icon={star} />
            <IonLabel>En curso</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value={ENDED}>
            <IonIcon icon={flag} />
            <IonLabel>Finalizadas</IonLabel>
          </IonSegmentButton>
        </IonSegment>
        <IonRow>
          <IonCol>
            <IonSearchbar
              id="portabilidad-searchbar"
              placeholder="Buscar"
              mode="ios"
              onIonInput={searchHandler}
              value={search}
            />
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol>
            <IonItem className="ion-align-items-center">
              <IonLabel id="fromDate">
                <span>Desde</span>
                <span className="dateSelected">{formatDate(startDate)}</span>
              </IonLabel>
              <IonModal id="date-popover" class="date-modal" ref={dateFromModal} trigger="fromDate">
                <IonContent>
                  <IonDatetime
                    id="portabilidad-ion-datetime-from"
                    name="startDate"
                    value={startDate}
                    max={endDate}
                    showDefaultButtons={true}
                    cancelText="Cancelar"
                    doneText="Aceptar"
                    presentation="date"
                    onIonChange={dateSelectHandler}
                  />
                </IonContent>
              </IonModal>
            </IonItem>
          </IonCol>
          <IonCol>
            <IonItem>
              <IonLabel id="toDate">
                <span>Hasta</span>
                <span className="dateSelected">{formatDate(endDate)}</span>
              </IonLabel>
              <IonModal id="date-popover" class="date-modal" ref={dateToModal} trigger="toDate">
                <IonContent>
                  <IonDatetime
                    id="portabilidad-ion-datetime-to"
                    name="endDate"
                    value={endDate}
                    min={startDate}
                    max={TODAY_DATE_STRING}
                    showDefaultButtons={true}
                    cancelText="Cancelar"
                    doneText="Aceptar"
                    presentation="date"
                    onIonChange={dateSelectHandler}
                  />
                </IonContent>
              </IonModal>
            </IonItem>
          </IonCol>
        </IonRow>
        {
          <ViewData
            procedure="portability"
            data={procedures}
            setShowActionSheet={setShowActionSheet}
            setData={viewProcedureDetail}
            title="TRÁMITES"
          />
        }
      </IonContent>
    </IonPage>
  )
}

export default Portabilidades
